import styled from 'styled-components';
import { SkeletonRectangle } from '..';
// *** Components ***
export const Dropdown = styled(SkeletonRectangle) `
  border-end-start-radius: 0;
  border-end-end-radius: 0;
`;
//# sourceMappingURL=skeleton-dropdown.styles.js.map